module.exports = __webpack_public_path__ + "media/components/partials/LandingComponents/General/Footer/img/linkedin-1d26ccdc02d70f620487a344acf8164a.svg";